import { AI_FEEDBACK_PATH, FeedbackRequest } from '@glow/ai-contract'

export type SendAiFeedback = (feedback: FeedbackRequest) => Promise<boolean>

export const sendAiFeedback: SendAiFeedback = async (feedback) => {
  const response = await fetch(AI_FEEDBACK_PATH, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(feedback)
  }).catch(() => null)
  return response?.ok ?? false
}
